<div>
    <div class="heading">
        <span (click)="onNoClick()"><mat-icon>close</mat-icon></span>
       
     </div>
     <div class="body-user">
        <fury-document-center-table [userId]="null" [claimId]="data?.claimId"></fury-document-center-table>
      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button mat-button mat-dialog-close class="can-button" (click)="onNoClick()"><span>Close</span></button>
    </div>
     </div>
     
</div>


